import React from 'react';
import styled from '@emotion/styled';
import { ContentContainer } from 'components';
import { RadialBarChart, StackBarChart, PieChart } from './Charts';
import NoDataChart from './Charts/NoDataChart';
import DashboardFilters from 'views/Dashboard/components/DashboardFilters';

export const StyledDashboardWidgets = styled.div({
  display: 'grid',
  gridTemplateColumns: '2fr 2fr 4fr',
  gridGap: 20,
  marginTop: '20px'
});

const StyledContainer = styled.div`
  display: grid;
  grid-gap: 10px;
`;

export const SeverityAndFiltersWidget = ({ data, filters, setFilters, scanSettingsList }) => {
  const { severity } = data;
  return (
    <StyledContainer>
      {filters && <DashboardFilters scanSettingsList={scanSettingsList} filters={filters} setFilters={setFilters} />}
      <ContentContainer>
        {severity ? (
          <PieChart data={severity} title="ERRORS BY SEVERITY" subtitle="Check1st Error Severity" />
        ) : (
          <NoDataChart title="ERRORS BY SEVERITY" subtitle="Check1st Error Severity" />
        )}
      </ContentContainer>
    </StyledContainer>
  );
};

const DashboardWidgets = ({ data }) => {
  const { drrasfag_to_severity, drrsfag, pour } = data;
  return (
    <StyledDashboardWidgets>
      <ContentContainer>
        {pour ? (
          <RadialBarChart
            title="ERRORS BY POUR"
            subtitle="POUR - Four Principles of Accessibility"
            colors={['#f1c40f', '#8e44ad', '#16a085', '#e74c3c']}
            data={pour}
          />
        ) : (
          <NoDataChart title="ERRORS BY POUR" subtitle="POUR - Four Principles of Accessibility" />
        )}
      </ContentContainer>
      <ContentContainer>
        {drrsfag ? (
          <RadialBarChart
            title="ERRORS BY DRRSFAG"
            subtitle="DRRSFAG - POUR Simplification"
            colors={['#2980b9', '#e67e22', '#e74c3c', '#2ecc71', '#162c69', '#fcc8ea', '#9d77aa']}
            data={drrsfag}
          />
        ) : (
          <NoDataChart title="ERRORS BY DRRSFAG" subtitle="DRRSFAG - POUR Simplification" />
        )}
      </ContentContainer>
      <ContentContainer>
        {drrasfag_to_severity ? (
          <StackBarChart
            data={drrasfag_to_severity}
            title="SEVERITY TO DRRASFAG"
            subtitle="Check1st Error Severity to DRRASFAG"
          />
        ) : (
          <NoDataChart title="SEVERITY TO DRRASFAG" subtitle="Check1st Error Severity to DRRASFAG" />
        )}
      </ContentContainer>
    </StyledDashboardWidgets>
  );
};
// colors.brand, colors.success.color, colors.warning.color
export default DashboardWidgets;
